import Loadable from "react-loadable";

export const PitchMoreMenu = Loadable({
  loader: () => import("../../../../modules/manage-pitch").then((module) => module.PitchMoreMenu) as Promise<any>,
  loading: () => null,
});
